import { FC, CSSProperties } from 'react';

type BusinessConceptsEmptyStateIconProps = {
  style?: CSSProperties;
  className?: string;
};

export const BusinessConceptsEmptyStateIcon: FC<
  BusinessConceptsEmptyStateIconProps
> = ({ style, className }) => {
  return (
    <svg
      viewBox="0 0 124 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <path
        d="M61.5714 92.5C57.9714 92.5 54.9286 91.2571 52.4429 88.7714C49.9571 86.2857 48.7143 83.2429 48.7143 79.6429C48.7143 76.6714 49.6 74.0571 51.3714 71.8C53.1429 69.5429 55.4 68.0143 58.1429 67.2143V59.9286H37.5714V46.2143H29V22.2143H53V46.2143H44.4286V53.0714H78.7143V45.7857C75.9714 44.9857 73.7143 43.4571 71.9429 41.2C70.1714 38.9429 69.2857 36.3286 69.2857 33.3571C69.2857 29.7571 70.5286 26.7143 73.0143 24.2286C75.5 21.7429 78.5429 20.5 82.1429 20.5C85.7429 20.5 88.7857 21.7429 91.2714 24.2286C93.7571 26.7143 95 29.7571 95 33.3571C95 36.3286 94.1143 38.9429 92.3429 41.2C90.5714 43.4571 88.3143 44.9857 85.5714 45.7857V59.9286H65V67.2143C67.7429 68.0143 70 69.5429 71.7714 71.8C73.5429 74.0571 74.4286 76.6714 74.4286 79.6429C74.4286 83.2429 73.1857 86.2857 70.7 88.7714C68.2143 91.2571 65.1714 92.5 61.5714 92.5Z"
        fill="#B0E5EC"
      />
      <g opacity="0.25" filter="url(#filter0_f_255_13173)">
        <ellipse
          cx="62"
          cy="120.5"
          rx="56"
          ry="8"
          fill="url(#paint0_radial_255_13173)"
          fillOpacity="0.75"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_255_13173"
          x="0.240001"
          y="106.74"
          width="123.52"
          height="27.52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.88"
            result="effect1_foregroundBlur_255_13173"
          />
        </filter>
        <radialGradient
          id="paint0_radial_255_13173"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(62 120.5) scale(56 303.565)"
        >
          <stop stopColor="#B0BEC5" />
          <stop offset="1" stopColor="#B0BEC5" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};
